import React from "react";
import { ArrowLeftIcon } from "lucide-react";
import { CutPlan } from "./CutPlan";
type PageHeroProps = {
  eyebrow: string;
  title: string;
  copy: string;
  accent?: "navy" | "steel" | "orange";
  children?: React.ReactNode;
};
function PageHero({
  eyebrow,
  title,
  copy,
  accent = "navy",
  children
}: PageHeroProps) {
  const accentClass = accent === "steel" ? "bg-pfpc-steel" : accent === "orange" ? "bg-pfpc-orange text-pfpc-navy" : "bg-pfpc-navy";
  const lightText = accent !== "orange";
  return <section className={`relative overflow-hidden ${accentClass}`} data-id="element-397" data-mp="25acsuyhr7ewz">
      <CutPlan dark={lightText} className="absolute inset-0 h-full w-full opacity-55" data-id="element-398" data-mp="2aa7jr21j44i1" />
      <div className="container-shell relative py-14 md:py-20 lg:py-24" data-id="element-399" data-mp="2a8egzxu1e4fb">
        <a href="/" className={`mb-8 inline-flex min-h-11 items-center gap-2 text-sm font-bold underline underline-offset-4 md:mb-10 ${lightText ? "text-pfpc-offwhite/70 hover:text-pfpc-offwhite" : "text-pfpc-navy/70 hover:text-pfpc-navy"}`} data-id="element-400" data-mp="2f28u2if4zl5f">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-401" data-mp="1wcsftg34rc5o" /> Back to home
        </a>
        <p className={`section-label mb-4 ${lightText ? "text-pfpc-orange" : "text-pfpc-navy/65"}`} data-id="element-402" data-mp="1wewki08usf70">{eyebrow}</p>
        <h1 className={`max-w-[18ch] font-heading text-[38px] font-extrabold leading-[1.08] tracking-[-.025em] md:text-[52px] md:leading-[1.04] lg:text-[56px] ${lightText ? "text-pfpc-offwhite" : "text-pfpc-navy"}`} data-id="element-403" data-mp="1mn8xqcn8rmbv">{title}</h1>
        <p className={`mt-6 max-w-[62ch] text-[17px] leading-7 md:text-xl md:leading-8 ${lightText ? "text-pfpc-offwhite/75" : "text-pfpc-navy/75"}`} data-id="element-404" data-mp="1dmubnb2ge37b">{copy}</p>
        {children ? <div className="mt-8 grid gap-3 sm:flex sm:flex-wrap" data-id="element-405" data-mp="13oem3cj2r1zx">{children}</div> : null}
      </div>
    </section>;
}
export { PageHero };